import clsx from "clsx";
import { Drawer } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import DrawerMenuItems from "./DrawerMenuItems";
import PlatformSidebarButton from "./PlatformSidebarButton";
import React from "react";
import { useAuth } from "../../contexts/authContext";
import layoutConstants from "../../constants/layoutConstants";
import useIsMobile from "../../hooks/useIsMobile";

const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: layoutConstants.drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: "336px",
        padding: "12px",
        top: "80px",
        height: "calc(100% - 80px)",
        boxSizing: "border-box",
        borderTop: "1px solid #E0E0E0",
    },
    impersonationShift: {
        marginTop: layoutConstants.impersonationBannerHeight,
    },
    mobileSiteSelectContainer: {
        color: theme.palette.getContrastText(theme.palette.primary.light),
        padding: theme.spacing(2),
    },
    mobileSiteSelectFormControl: {
        width: "100%",
        color: "inherit",
        "& .MuiFormLabel-root": {
            color: "inherit",
        },
        "& .MuiSelect-icon": {
            color: "inherit",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "inherit",
            opacity: 0.5,
        },
        "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "inherit",
            opacity: 1,
        },
        "& .MuiInputBase-root": {
            color: "inherit",
        },
        "& option": {
            color: "black",
        },
    },
}));

const container = window !== undefined ? () => window.document.body : undefined;

function PlatformNavigationDrawer({ isOpen, onToggleOpen }) {
    const classes = useStyles();
    const isMobile = useIsMobile();

    const { impersonatingUser } = useAuth();

    return isMobile ? (
        <Drawer
            className={classes.drawer}
            variant={"temporary"}
            anchor="left"
            container={container}
            open={isOpen}
            onClose={onToggleOpen}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            classes={{
                paper: clsx(classes.drawerPaper, {
                    [classes.impersonationShift]: !!impersonatingUser,
                }),
            }}
        >
            <DrawerMenuItems />
            <PlatformSidebarButton />
        </Drawer>
    ) : (
        <Drawer
            className={classes.drawer}
            variant={"persistent"}
            anchor="left"
            open={isOpen}
            classes={{
                paper: clsx(classes.drawerPaper, {
                    [classes.impersonationShift]: !!impersonatingUser,
                }),
            }}
        >
            <DrawerMenuItems />
            <PlatformSidebarButton />
        </Drawer>
    );
}

export default PlatformNavigationDrawer;
